export const education = [
  {
    degree: "B.Tech in Computer Science and Engineering",
    school: "LBS College of Engineering Kasaragod",
    year: "2021–2025",
  },
  {
    degree: "Higher Secondary Education",
    school: "JNMGHSS Puthuppanam, Vadakara",
    year: "2019–2021",
  },
  {
    degree: "High School Education",
    school: "JNMGHSS Puthuppanam, Vadakara",
    year: "2016–2019",
  }
];
